/** Air-pressure units the weather tools accept. */
export type PressureUnit = "hPa" | "kPa" | "inHg" | "mmHg";

/** Hectopascals in one unit. 1 inHg = 33.8639 hPa and 1 mmHg = 1.333224 hPa. */
const HPA_PER_UNIT: Record<PressureUnit, number> = {
  hPa: 1,
  kPa: 10,
  inHg: 33.8639,
  mmHg: 1.333_224,
};

export function toHectopascals(value: number, unit: PressureUnit): number {
  return value * HPA_PER_UNIT[unit];
}

export function fromHectopascals(hpa: number, unit: PressureUnit): number {
  return hpa / HPA_PER_UNIT[unit];
}
